/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hist_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tall central bar with shorter bars either side indicates a roughly normal distribution.`)
};

const es_hist_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una barra central alta con barras más cortas a los lados indica una distribución aproximadamente normal.`)
};

const de_hist_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein hoher zentraler Balken mit kürzeren Balken auf beiden Seiten deutet auf eine annähernd normalverteilte Verteilung hin.`)
};

const nl_hist_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een hoge middelste staaf met kortere staven aan weerszijden duidt op een min of meer normale verdeling.`)
};

const fr_hist_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une grande barre centrale avec des barres plus courtes de chaque côté indique une distribution à peu près normale.`)
};

const it_hist_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una barra centrale alta con barre più corte ai lati indica una distribuzione approssimativamente normale.`)
};

const pt_br2_hist_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma barra central alta com barras menores dos dois lados indica uma distribuição aproximadamente normal.`)
};

const pt_hist_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma barra central alta com barras mais curtas de ambos os lados indica uma distribuição aproximadamente normal.`)
};

const ja_hist_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中央に高い棒があり両側に低い棒がある場合、ほぼ正規分布であることを示します。`)
};

const zh_hist_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中间高、两侧逐渐降低的柱子表示大致的正态分布。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hist_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hist_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hist_ex1", locale)
	if (locale === "en") return en_hist_ex1(inputs)
	if (locale === "es") return es_hist_ex1(inputs)
	if (locale === "de") return de_hist_ex1(inputs)
	if (locale === "nl") return nl_hist_ex1(inputs)
	if (locale === "fr") return fr_hist_ex1(inputs)
	if (locale === "it") return it_hist_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_hist_ex1(inputs)
	if (locale === "pt") return pt_hist_ex1(inputs)
	if (locale === "ja") return ja_hist_ex1(inputs)
	return zh_hist_ex1(inputs)
};